<template>
  <div>
    <div class="flex flex-around mb10">
      <div
        class="flex-1 flex flex-center purchase-data p20"
        :class="{ mr10: i < list.length - 1 }"
        v-for="(v, i) in list"
        :key="i"
      >
        <div class="hm-icon mr10">
          <span class="hmicon" :class="v.icon"></span>
        </div>
        <div class="flex flex-column flex-center">
          <div class="purchase-name">
            {{ v.name }}
          </div>
          <div class="purchase-val mt10">
            {{ v.val }}
          </div>
        </div>
      </div>
    </div>
    <hm-content title="">
      <div class="table-panel flex flex-end">
        <el-date-picker
          v-model="searchCondition.createTimeArry"
          :default-time="['00:00:00', '23:59:59']"
          type="datetimerange"
          value-format="yyyy-MM-dd HH:mm:ss"
          align="right"
          size="small"
          class="mr10"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
        <el-button type="primary" size="small" @click="search">查询</el-button>
      </div>
      <div class="">
        <el-table
          stripe
          ref="btable"
          :data="planList"
          style="width: 100%"
          id="table"
          size="small"
        >
          <el-table-column type="index" label="序号"></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="sendTitle"
            label="推送标题"
            width="250"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="triggerTime"
            label="推送时间"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="visitNum"
            label="覆盖次数"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="noticeNum"
            label="通知次数"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="proportion"
            label="复购率"
          >
          </el-table-column>
          <el-table-column header-align="center" align="center" label="状态">
            <template slot-scope="scope">
              <div v-if="scope.row.recordStatus === 'success'">
                <span class="success">已完成</span>
                <!-- <template v-if="scope.row.isHaveErrorMsg">
                  <span
                    style="font-size: 14px"
                    class="hmicon icon-tishi1 danger ml10"
                  ></span>
                  <span class="danger"> 有失败消息</span>
                  <el-button size="small" class="blue" type="text"
                    >查看详情</el-button
                  >
                </template> -->
              </div>
              <div v-if="scope.row.recordStatus === 'errorStop'" class="danger">
                异常暂停
                <span style="font-size: 14px" class="hmicon icon-tishi1"></span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="操作"
            width="200"
          >
            <template slot-scope="scope">
              <el-button
                size="small"
                class="blue"
                type="text"
                @click="singelUser(scope.row)"
                >详细用户</el-button
              >
              <el-divider direction="vertical"></el-divider>
              <el-button
                size="small"
                class="blue"
                type="text"
                @click="singelMsg(scope.row)"
                >本次数据统计</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="total"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="currentPage"
        ></el-pagination>
      </div>
    </hm-content>
  </div>
</template>

<script>
import moment from "moment";
export default {
  components: {},
  data() {
    return {
      list: [
        {
          icon: "icon-tongzhirenshu1",
          name: "今日实时复购订单数（单）",
          val: "0",
          pathName: ""
        },
        {
          icon: "icon-tongzhirenshu1",
          name: "最近7天复购提醒次数（次）",
          val: "0",
          pathName: ""
        },
        {
          icon: "icon-tongzhirenshu1",
          name: "全部复购提醒次数（次）",
          val: "0",
          pathName: "PotentialGoods"
        }
      ],
      planList: [],
      total: 0,
      pageSize: 10,
      currentPage: 1,
      searchCondition: {
        createTimeArry: [
          moment().format("YYYY-MM-DD") + " 00:00:00",
          moment().format("YYYY-MM-DD") + " 23:59:59"
        ]
      }
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.queryList();
    this.queryRepurchasePlanExecRecordNum();
  },
  methods: {
    async queryRepurchasePlanExecRecordNum() {
      const { code, result } = await this.$store.dispatch(
        "queryRepurchasePlanExecRecordNum",
        {
          planType: "repurchase"
        }
      );
      if (code === "0") {
        this.list[0].val = result.todayNum;
        this.list[1].val = result.sevenDaysNum;
        this.list[2].val = result.allNum;
      }
    },
    async queryList() {
      if (
        this.searchCondition.createTimeArry &&
        this.searchCondition.createTimeArry.length > 0
      ) {
        const params = {
          pageSize: this.pageSize,
          pageNo: this.currentPage,
          planType: "repurchase"
        };
        const searchCondition = JSON.parse(
          JSON.stringify(this.searchCondition)
        );
        searchCondition.queryStartTime =
          this.searchCondition.createTimeArry &&
          this.searchCondition.createTimeArry.length > 0
            ? this.searchCondition.createTimeArry[0]
            : null;
        searchCondition.queryEndTime =
          this.searchCondition.createTimeArry &&
          this.searchCondition.createTimeArry.length > 0
            ? this.searchCondition.createTimeArry[1]
            : null;
        Object.assign(params, searchCondition);
        const { code, result } = await this.$store.dispatch(
          "queryRepurchasePlanExecRecordList",
          params
        );
        if (code === "0") {
          const { total, records } = result;
          records.forEach(v => {
            if (v.payNum && v.noticeNum) {
              v.proportion = ((v.payNum / v.noticeNum) * 100).toFixed(2) + "%";
            } else {
              v.proportion = "0%";
            }
          });
          this.planList = records;
          this.total = total;
        }
      } else {
        this.$message({
          message: "请选择时间段",
          type: "warning"
        });
      }
    },

    singelUser(row) {
      this.$router.push({
        name: "SingleUserDetails",
        query: {
          row: JSON.stringify(row)
        }
      });
    },
    singelMsg(row) {
      this.$router.push({
        name: "SingleMessageStatistics",
        query: {
          row: JSON.stringify(row)
        }
      });
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    }
  }
};
</script>
<style lang='scss' scoped>
.purchase-data {
  box-shadow: 0px 0px 18px 0px rgba(221, 221, 221, 0.39);
  border-radius: 6px;
  background: #ffffff;
  .hm-icon {
    width: 66px;
    height: 66px;
    border-radius: 50%;
    text-align: center;
    line-height: 66px;
    background: #feeef5;
    .hmicon {
      font-size: 25px;
      color: #e50065;
    }
  }
  .purchase-name {
    color: #222222;
    font-size: 14px;
  }
  .purchase-val {
    font-size: 24px;
    font-weight: bold;
  }
}
</style>
